import AccordionBlock from "./AccordionBlock";

export default AccordionBlock;
